import { ServicesLoaders } from '@wix/thunderbolt-symbols'
import { NamedSignalsServiceDefinition, TestServiceDefinition } from '@wix/thunderbolt-services'
import namedSignalsServiceConfig from './configs/namedSignalsServiceConfig'
import { StyleUtilsDefinition } from '@wix/style-utils'

export const serviceLoaders: ServicesLoaders = {
	[TestServiceDefinition as string]: () => import('feature-test-service/service' /* webpackChunkName: "platformTestService" */),
	[NamedSignalsServiceDefinition as string]: () => import('feature-named-signals-service/service' /* webpackChunkName: "platformNamedSignalsService" */),
	[StyleUtilsDefinition as string]: () => import('feature-style-utils-service/service' /* webpackChunkName: "platformStyleUtilsService" */),
}

export const serviceConfigs: { [serviceDefinition: string]: any } = {
	[NamedSignalsServiceDefinition as string]: namedSignalsServiceConfig,
}
